export const BULK_ADD_DRIVERID_TAGS_OPEN_MODAL = "BULK_ADD_DRIVERID_TAGS_OPEN_MODAL";
export const BULK_ADD_DRIVERID_TAGS_CLOSE_MODAL = "BULK_ADD_DRIVERID_TAGS_CLOSE_MODAL";
export const BULK_ADD_DRIVERID_TAGS_VALIDATE_REQUEST = "BULK_ADD_DRIVERID_TAGS_VALIDATE_REQUEST";
export const BULK_ADD_DRIVERID_TAGS_VALIDATE_RESULT = "BULK_ADD_DRIVERID_TAGS_VALIDATE_RESULT";
export const BULK_ADD_DRIVERID_TAGS_IMPORT_REQUEST = "BULK_ADD_DRIVERID_TAGS_IMPORT_REQUEST";
export const BULK_ADD_DRIVERID_TAGS_IMPORT_RESULT = "BULK_ADD_DRIVERID_TAGS_IMPORT_RESULT";